import {Component, computed, inject, input, output} from '@angular/core';
import {toObservable, toSignal} from '@angular/core/rxjs-interop';
import {of, switchMap} from 'rxjs';
import {Button} from 'primeng/button';
import {TooltipModule} from 'primeng/tooltip';
import {TranslocoPipe, TranslocoService} from '@jsverse/transloco';
import {DirectusService, Tooltip} from '@frontend/directus';

@Component({
  selector: 'app-model-field-button',
  imports: [Button, TooltipModule, TranslocoPipe],
  templateUrl: './model-field-button.component.html',
})
export class ModelFieldButtonComponent {
  private readonly directusService = inject(DirectusService);
  private readonly transloco = inject(TranslocoService);

  id = input<string>('');
  icon = input<string>();
  text = input<string>();
  disabled = input<boolean>(false);
  active = input<boolean>(false);
  tooltipKey = input<string>('');
  tooltipPosition = input<string>('top');
  styleClass = input<string>('');

  readonly clicked = output<void>();

  private readonly currentLang = toSignal(this.transloco.langChanges$, {
    initialValue: this.transloco.getActiveLang(),
  });

  private readonly directusTooltip = toSignal(
    toObservable(this.tooltipKey).pipe(
      switchMap((key) => (key ? this.directusService.loadTooltipByKey(key) : of(null))),
    ),
    {initialValue: null as Tooltip | null},
  );

  readonly tooltipText = computed(() => {
    const data = this.directusTooltip();
    const lang = this.currentLang();
    const match = data?.translations?.find((translation) => translation.language === lang);
    return match?.tooltipText ?? data?.translations?.[0]?.tooltipText ?? '';
  });
}
